import { render, useState, useEffect } from '@wordpress/element';

function TourFilterApp() {
    const [filters, setFilters] = useState({
        destination: '',
        tour_type: '',
        departure: '',
        budget_max: '2000',
        tour_line: [],
        transport: [],
        sort_by: 'newest',
        paged: 1
    });

    const [toursHtml, setToursHtml] = useState('<div style="padding: 40px; text-align: center; grid-column: 1 / -1;">Đang tải danh sách tour...</div>');
    const [paginationHtml, setPaginationHtml] = useState('');
    const [tourCount, setTourCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const taxonomies = window.tour_filter_vars.taxonomies || {};

    // Fetch tours whenever filters change
    useEffect(() => {
        const fetchTours = () => {
            setLoading(true);
            const ajaxData = {
                action: 'filter_tours',
                paged: filters.paged,
                sort_by: filters.sort_by,
                budget_max: filters.budget_max
            };

            if (filters.destination) ajaxData.destination = filters.destination;
            if (filters.tour_type) ajaxData.tour_type = filters.tour_type;
            if (filters.departure) ajaxData.departure = filters.departure;
            if (filters.tour_line.length > 0) ajaxData.tour_line = filters.tour_line.join(',');
            if (filters.transport.length > 0) ajaxData.transport = filters.transport.join(',');

            const baseAjaxUrl = window.tour_filter_vars.ajax_url;
            let finalAjaxUrl = baseAjaxUrl;
            try {
                const parsedUrl = new URL(baseAjaxUrl);
                finalAjaxUrl = window.location.origin + parsedUrl.pathname + parsedUrl.search;
            } catch (e) {
                console.error("Invalid AJAX URL");
            }

            window.jQuery.ajax({
                url: finalAjaxUrl,
                type: 'POST',
                data: ajaxData,
                success: (result) => {
                    if (result.success) {
                        setToursHtml(result.data.html);
                        setTourCount(result.data.count);
                        setPaginationHtml(result.data.pagination || '');
                    }
                },
                error: (xhr, status, error) => {
                    console.error('Error fetching tours:', error);
                    setToursHtml('<div style="padding: 40px; text-align: center; color: red;">Lỗi tải dữ liệu. Vui lòng thử lại.</div>');
                },
                complete: () => {
                    setLoading(false);
                }
            });
        };

        const debounceTimer = setTimeout(() => {
            fetchTours();
        }, 500);

        return () => clearTimeout(debounceTimer);
    }, [filters]);

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value, paged: 1 }));
    };

    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        setFilters(prev => {
            const currentArr = prev[name];
            let newArr;
            if (checked) {
                newArr = [...currentArr, value];
            } else {
                newArr = currentArr.filter(item => item !== value);
            }
            return { ...prev, [name]: newArr, paged: 1 };
        });
    };

    const handlePaginationClick = (e) => {
        if (e.target.tagName === 'A') {
            e.preventDefault();
            const href = e.target.getAttribute('href');
            const url = new URL(href, window.location.origin);
            const paged = url.searchParams.get('paged') || 1;
            setFilters(prev => ({ ...prev, paged: parseInt(paged) }));
            window.scrollTo({ top: document.querySelector('.tour-archive-filter-widget').offsetTop - 50, behavior: 'smooth' });
        }
    };

    return (
        <div className="tafw-container">
            {/* SIDEBAR FILTER */}
            <aside className="tafw-sidebar">
                <form className="tour-filter-form" onSubmit={e => e.preventDefault()}>
                    <div className="tafw-filter-header">
                        <h3 style={{display: 'flex', alignItems: 'center'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a8191e" className="bi bi-funnel-fill" viewBox="0 0 16 16" style={{marginRight: '8px'}}> 
                                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/> 
                            </svg>
                            Bộ lọc tìm kiếm
                        </h3>
                    </div>

                    {taxonomies.destination && taxonomies.destination.length > 0 && (
                        <div className="tafw-filter-group">
                            <label className="tafw-label" style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#092340" className="bi bi-geo-alt-fill" viewBox="0 0 16 16" style={{ marginRight: '6px' }}>
                                  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                                </svg>
                                Điểm đến
                            </label>
                            <select name="destination" className="tafw-select" value={filters.destination} onChange={handleSelectChange}>
                                <option value="">Tất cả điểm đến</option>
                                {taxonomies.destination.map(term => (
                                    <option key={term.slug} value={term.slug}>{term.name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {taxonomies.tour_type && taxonomies.tour_type.length > 0 && (
                        <div className="tafw-filter-group">
                            <label className="tafw-label" style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#092340" className="bi bi-camera-fill" viewBox="0 0 16 16" style={{ marginRight: '6px' }}>
                                  <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                                  <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>
                                </svg>
                                Loại hình Tour
                            </label>
                            <select name="tour_type" className="tafw-select" value={filters.tour_type} onChange={handleSelectChange}>
                                <option value="">Tất cả loại hình</option>
                                {taxonomies.tour_type.map(term => (
                                    <option key={term.slug} value={term.slug}>{term.name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {taxonomies.departure && taxonomies.departure.length > 0 && (
                        <div className="tafw-filter-group">
                            <label className="tafw-label" style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#092340" className="bi bi-airplane-fill" viewBox="0 0 16 16" style={{ marginRight: '6px' }}>
                                  <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Z"/>
                                </svg>
                                Điểm khởi hành
                            </label>
                            <select name="departure" className="tafw-select" value={filters.departure} onChange={handleSelectChange}>
                                <option value="">Tất cả điểm khởi hành</option>
                                {taxonomies.departure.map(term => (
                                    <option key={term.slug} value={term.slug}>{term.name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    <div className="tafw-filter-group">
                        <label className="tafw-label" style={{display: 'flex', alignItems: 'center'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#092340" className="bi bi-wallet-fill" viewBox="0 0 16 16" style={{marginRight: '6px'}}> 
                                <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z"/> <path d="M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z"/> 
                            </svg>
                            Ngân sách
                        </label>
                        <div className="tafw-range-slider">
                            <input 
                                type="range" 
                                name="budget_max" 
                                min="0" max="2000" step="50" 
                                value={filters.budget_max} 
                                onChange={handleSelectChange} 
                            />
                            <div className="range-value-display">${parseInt(filters.budget_max).toLocaleString('en-US')}</div>
                        </div>
                    </div>

                    {taxonomies.tour_line && taxonomies.tour_line.length > 0 && (
                        <div className="tafw-filter-group">
                            <label className="tafw-label" style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#092340" className="bi bi-tags-fill" viewBox="0 0 16 16" style={{ marginRight: '6px' }}>
                                  <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                                  <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z"/>
                                </svg>
                                Dòng tour
                            </label>
                            <div className="tafw-checkbox-list">
                                {taxonomies.tour_line.map(term => (
                                    <label key={term.slug} className="tafw-checkbox-label">
                                        <input 
                                            type="checkbox" 
                                            name="tour_line" 
                                            value={term.slug} 
                                            checked={filters.tour_line.includes(term.slug)}
                                            onChange={handleCheckboxChange} 
                                        />
                                        <span>{term.name} ({term.count})</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}

                    {taxonomies.transport && taxonomies.transport.length > 0 && (
                        <div className="tafw-filter-group">
                            <label className="tafw-label" style={{ display: 'flex', alignItems: 'center' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#092340" className="bi bi-bus-front-fill" viewBox="0 0 16 16" style={{ marginRight: '6px' }}>
                                  <path d="M16 7a5.5 5.5 0 0 0-4.47-5.414C10.15 1.144 8.98 1 8 1S5.85 1.144 4.47 1.586A5.5 5.5 0 0 0 0 7v5c0 .828.672 1.5 1.5 1.5h.191l.98 1.96A.5.5 0 0 0 3.118 16h.044a.5.5 0 0 0 .447-.276L4.364 14h7.272l.755 1.724a.5.5 0 0 0 .447.276h.044a.5.5 0 0 0 .447-.224l.98-1.96h.191A1.5 1.5 0 0 0 16 12V7ZM2.5 7.75A1.25 1.25 0 1 1 2.5 5.25 1.25 1.25 0 0 1 2.5 7.75Zm11 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM2 10.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm1-6a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm10 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/>
                                </svg>
                                Phương tiện
                            </label>
                            <div className="tafw-checkbox-list">
                                {taxonomies.transport.map(term => (
                                    <label key={term.slug} className="tafw-checkbox-label">
                                        <input 
                                            type="checkbox" 
                                            name="transport" 
                                            value={term.slug} 
                                            checked={filters.transport.includes(term.slug)}
                                            onChange={handleCheckboxChange} 
                                        />
                                        <span>{term.name} ({term.count})</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}
                </form>
            </aside>

            {/* MAIN CONTENT */}
            <main className="tafw-main-content">
                <div className="tafw-top-bar">
                    <div className="tour-active-filters" style={{display: 'none'}}></div>
                    
                    <div className="tafw-results-meta">
                        <div className="tour-result-count" style={{display: 'flex', alignItems: 'center'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a8191e" className="bi bi-list-ul" viewBox="0 0 16 16" style={{marginRight: '8px'}}> 
                                <path fillRule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/> 
                            </svg>
                            Hiển thị <span style={{ margin: '0 4px' }}>{tourCount}</span> chương trình tour
                        </div>
                        <div className="tour-sort">
                            <select className="tour-sort-select" name="sort_by" value={filters.sort_by} onChange={handleSelectChange}>
                                <option value="newest">Sắp xếp theo: Đề xuất</option>
                                <option value="price_asc">Giá: Thấp đến Cao</option>
                                <option value="price_desc">Giá: Cao đến Thấp</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div 
                    className={`tour-results-grid tour-grid ${loading ? 'loading' : ''}`} 
                    style={{opacity: loading ? 0.5 : 1}}
                    dangerouslySetInnerHTML={{ __html: toursHtml }}
                />

                <div 
                    className="tour-pagination-container" 
                    onClick={handlePaginationClick}
                    dangerouslySetInnerHTML={{ __html: paginationHtml }}
                />
            </main>
        </div>
    );
}

function mountApp() {
    const rootEl = document.getElementById('tour-react-filter-root');
    if (rootEl) {
        render(<TourFilterApp />, rootEl);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountApp);
} else {
    mountApp();
}
